import { Modal, Tooltip, initFlowbite, Dismiss } from 'flowbite';

let fflate; // Variabile per la libreria fflate (zip)

document.addEventListener('DOMContentLoaded', () => {
    // --- Elementi DOM ---
    const appContainer = document.getElementById('ar-frontend-app');
    if (!appContainer) return;

    const messagesWrapper = document.getElementById('ar-frontend-messages-wrapper');
    const messagesContainer = document.getElementById('ar-frontend-messages');
    const loginContainer = document.getElementById('ar-login-container');
    const fileManagerContainer = document.getElementById('ar-file-manager-container');
    const passwordInput = document.getElementById('ar-password');
    const loginButton = document.getElementById('ar-login-button');
    const folderTitle = document.getElementById('ar-folder-title');
    const breadcrumbContainer = document.getElementById('ar-breadcrumb')?.querySelector('ol'); // Aggiunto controllo
    const downloadZipButton = document.getElementById('ar-download-zip-button');
    const logoutButton = document.getElementById('ar-logout-button');
    const zipSpinner = document.getElementById('ar-zip-spinner');
    const fileTableBody = document.getElementById('ar-file-table-body');

    // --- Stato Applicazione ---
    let currentPath = '';
    let baseAccessPath = '';
    let currentFolderName = '';
    let isLoading = false;

    // --- Configurazione ---
    const config = window.ar_frontend_config || {};
    const { ajax_url, nonce, text, initial_state, fflate_cdn_url, cookie_name } = config;

    // --- Funzioni Helper ---
    const showMessage = (message, type = 'info', sticky = false) => {
        if (!messagesContainer || !messagesWrapper) return;
        const alertClasses = { success: 'text-green-800 bg-green-50 dark:bg-gray-900 dark:text-green-400 border border-green-300 dark:border-green-800', error: 'text-red-800 bg-red-50 dark:bg-gray-900 dark:text-red-400 border border-red-300 dark:border-red-800', warning: 'text-yellow-800 bg-yellow-50 dark:bg-gray-900 dark:text-yellow-300 border border-yellow-300 dark:border-yellow-800', info: 'text-blue-800 bg-blue-50 dark:bg-gray-900 dark:text-blue-400 border border-blue-300 dark:border-blue-800', };
        const iconSvg = { success: `<svg class="flex-shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20"><path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/></svg>`, error: `<svg class="flex-shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20"><path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/></svg>`, warning: `<svg class="flex-shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20"><path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/></svg>`, info: `<svg class="flex-shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20"><path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/></svg>` };
        const alertId = `alert-frontend-${Date.now()}`; const alertDiv = document.createElement('div'); alertDiv.id = alertId;
        alertDiv.className = `flex items-center p-4 text-sm rounded-lg ${alertClasses[type] || alertClasses.info}`;
        alertDiv.setAttribute('role', 'alert');
        alertDiv.innerHTML = `${iconSvg[type] || iconSvg.info}<span class="sr-only">${type}</span><div class="ms-3 text-sm font-medium">${message}</div><button type="button" class="ms-auto -mx-1.5 -my-1.5 rounded-lg focus:ring-2 p-1.5 inline-flex items-center justify-center h-8 w-8 ${alertClasses[type].replace(/text-(\w+)-800\sbg-(\w+)-50/g, 'text-$1-500 bg-transparent focus:ring-$1-400 hover:bg-$1-200 dark:text-$2-400 dark:hover:bg-gray-700')}" data-dismiss-target="#${alertId}" aria-label="Chiudi"><span class="sr-only">Chiudi</span><svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/></svg></button>`;

        messagesContainer.innerHTML = ''; messagesContainer.appendChild(alertDiv);
        messagesWrapper.hidden = false;

        const hideAlert = () => {
            const activeAlert = document.getElementById(alertId);
            if(activeAlert) {
                activeAlert.remove();
                if (messagesContainer.children.length === 0) {
                    messagesWrapper.hidden = true;
                }
            }
        };
        if (!sticky) { setTimeout(hideAlert, 5000); }
        else { const dismissButton = alertDiv.querySelector(`[data-dismiss-target="#${alertId}"]`); if (dismissButton) { dismissButton.addEventListener('click', hideAlert); } }
    };
    const formatDateOnly = (timestamp) => { if (!timestamp) return ''; const date = new Date(timestamp * 1000); const options = { day: '2-digit', month: '2-digit', year: 'numeric' }; return date.toLocaleDateString('it-IT', options); };
    const formatFileSize = (bytes) => { if (bytes === 0) return '0 B'; const k = 1024; const sizes = ['B', 'KB', 'MB', 'GB', 'TB']; const i = Math.floor(Math.log(bytes) / Math.log(k)); return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]; };
    const getTypeColorClass = (type) => { const colors = { folder: 'text-yellow-400', image: 'text-blue-600', pdf: 'text-red-600', archive: 'text-purple-600', code: 'text-orange-500', document: 'text-sky-500', unknown: 'text-gray-500', }; return colors[type] || colors['unknown']; };
    const getFileType = (filename) => { const ext = filename.split('.').pop()?.toLowerCase() || ''; if (!ext || filename.lastIndexOf('.') === -1) return 'unknown'; const types = { image: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'ico'], pdf: ['pdf'], archive: ['zip', 'rar', '7z', 'tar', 'gz', 'bz2'], code: ['php', 'js', 'css', 'html', 'htm', 'json', 'xml', 'py', 'sh', 'sql', 'jsx', 'ts'], document: ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'odt', 'ods', 'odp', 'txt', 'rtf', 'csv', 'md'], }; for (const type in types) { if (types[type].includes(ext)) return type; } return 'unknown'; };
    const getIconClass = (type) => {
        const iconClasses = {
            folder: 'fa-solid fa-folder',
            image: 'fa-solid fa-file-image',
            pdf: 'fa-solid fa-file-pdf',
            archive: 'fa-solid fa-file-zipper',
            code: 'fa-solid fa-file-code',
            document: 'fa-solid fa-file-lines',
            unknown: 'fa-solid fa-file',
            download: 'fa-solid fa-download',
            home: 'fa-solid fa-house',
            chevronLeft: 'fa-solid fa-chevron-left',
            chevronRight: 'fa-solid fa-chevron-right',
            download_zip: 'fa-solid fa-file-zipper',
            logout: 'fa-solid fa-right-from-bracket',
        };
        const key_map = {
            'chevron-left': 'chevronLeft',
            'chevron-right': 'chevronRight',
        };
        const key = key_map[type] ?? type;
        return iconClasses[key] || iconClasses['unknown'];
    };

    const sanitizeHashPath = (hash) => {
        if (!hash || hash === '#') return '';
        try {
            let path = decodeURIComponent(hash.substring(1));
            path = path.replace(/^[/\\]+|[/\\]+$/g, '');
            path = path.replace(/[\\/]+/g, '/');
            if (path.includes('..')) return '';
            // Verifica che il percorso sanificato inizi con il percorso base consentito
            // Gestisce il caso in cui baseAccessPath sia vuoto (accesso alla root)
            if (baseAccessPath !== '' && path.indexOf(baseAccessPath) !== 0 && path !== '') {
                 return baseAccessPath; // Forza il ritorno alla base se si tenta di uscire
            }
            return path;
        } catch (e) {
            console.error("Errore decodifica hash:", e);
            return baseAccessPath || ''; // Ritorna il percorso base in caso di errore
        }
    };

    const clearAccessCookie = () => {
        if (cookie_name) {
            // Imposta HttpOnly a false per permettere la cancellazione via JS
            document.cookie = `${cookie_name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; Max-Age=0; path=/; SameSite=Lax`;
        }
    }

    const makeAjaxRequest = async (action, data = {}, method = 'POST') => {
        if (isLoading) return Promise.reject('Loading...');
        isLoading = true;
        const formData = new FormData();
        formData.append('action', action);
        if (action === 'ar_frontend_login') {
            formData.append('nonce', nonce); // Aggiungi nonce solo per il login
        }
        // Per altre azioni frontend, il token nel cookie viene verificato lato server
        for (const key in data) {
            formData.append(key, data[key]);
        }

        try {
            const response = await fetch(ajax_url, { method: method, body: formData });
            isLoading = false;

            if (!response.ok) {
                let errorMsg = text.error_general;
                let errorCode = null;
                let errorData = null;
                try {
                    errorData = await response.json();
                    errorMsg = errorData?.data?.message || errorData?.message || errorMsg;
                    errorCode = errorData?.data?.code || null;
                } catch (e) {
                    errorMsg = response.statusText || errorMsg;
                }

                // Se l'errore è di autenticazione (token mancante/invalido), mostra messaggio e ricarica
                if (response.status === 401 || errorCode === 'NO_TOKEN' || errorCode === 'INVALID_TOKEN') {
                    showMessage(text.error_session_expired, 'error', true);
                    setTimeout(() => window.location.reload(), 3000);
                    throw new Error('Session expired'); // Lancia errore specifico per bloccare ulteriori azioni
                }
                throw new Error(errorMsg); // Lancia errore generico per altri problemi
            }

            const result = await response.json();
            if (!result.success) {
                 // Controlla di nuovo il codice errore anche in caso di success=false
                 if (result.data?.code === 'NO_TOKEN' || result.data?.code === 'INVALID_TOKEN') {
                     showMessage(text.error_session_expired, 'error', true);
                     setTimeout(() => window.location.reload(), 3000);
                     throw new Error('Session expired');
                 }
                throw new Error(result.data?.message || text.error_general);
            }
            return result.data;

        } catch (error) {
            isLoading = false;
            // Non mostrare il messaggio generico se è un errore di sessione già gestito
            if (error.message !== 'Session expired') {
                 showMessage(error.message || text.error_general, 'error');
            }
            throw error; // Rilancia l'errore per interrompere il flusso se necessario
        }
    };

    // --- Funzioni UI ---
    const showView = (view) => {
        if (loginContainer) loginContainer.hidden = (view !== 'login');
        if (fileManagerContainer) fileManagerContainer.hidden = (view !== 'manager');
    };

    const renderTable = (items) => {
        if (!fileTableBody) return;
        fileTableBody.innerHTML = '';
        if (!items || items.length === 0) { fileTableBody.innerHTML = `<tr class="border-b dark:border-gray-700"><td colspan="4" class="px-4 py-6 text-center text-gray-500 dark:text-gray-400">Nessun file o cartella trovata.</td></tr>`; return; }
        items.forEach(item => {
            const row = document.createElement('tr');
            const fileType = item.isDir ? 'folder' : getFileType(item.name);
            // *** MODIFICA: cursor-pointer su tutte le righe ***
            row.className = `border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 cursor-pointer`;
            row.dataset.relativePath = item.relativePath; row.dataset.isDir = item.isDir; row.dataset.name = item.name; row.dataset.url = item.url; // URL diretto per lightbox

            const iconColorClass = getTypeColorClass(fileType); const nameColorClass = 'text-accent dark:text-accent';
            const iconClass = getIconClass(fileType);
            const iconHtml = `<i class="${iconClass} ${iconColorClass} fa-lg fa-fw mr-2"></i>`;
            const downloadIconHtml = !item.isDir ? `<i class="${getIconClass('download')} w-5 h-5"></i>` : '';
            // *** CORREZIONE: Assicurati che l'URL nel link nascosto sia quello diretto ***
            const hiddenLink = fileType === 'image' ? `<a href="${item.url}" data-lightbox-trigger style="display: none;"></a>` : '';

            const tdClasses = "px-4 py-3 align-middle";
            const nameTdClasses = `${tdClasses} font-medium text-primary-dark dark:text-white overflow-hidden text-ellipsis whitespace-nowrap`;
            const sizeTdClasses = `${tdClasses} text-primary-dark dark:text-gray-400 whitespace-nowrap`;
            const dateTdClasses = `${tdClasses} text-primary-dark dark:text-gray-400 whitespace-nowrap`;
            const actionTdClasses = `${tdClasses} w-12 text-center`;


            row.innerHTML = `
                <td class="${nameTdClasses}">
                    <div class="flex items-center">
                        ${iconHtml}
                        <span class="${nameColorClass}">${item.name}</span>
                         ${hiddenLink}
                    </div>
                </td>
                <td class="${sizeTdClasses}">${item.isDir ? '-' : formatFileSize(item.size)}</td>
                <td class="${dateTdClasses}">${formatDateOnly(item.mtime)}</td>
                <td class="${actionTdClasses}">
                    ${!item.isDir ? `
                    <button type="button" class="ar-download-btn p-1 text-gray-500 hover:text-accent dark:text-gray-400 dark:hover:text-accent dark:hover:bg-gray-700 rounded" data-tooltip-target="tooltip-download-${item.relativePath.replace(/[^a-zA-Z0-9]/g, '-')}" data-path="${item.relativePath}" data-name="${item.name}" data-url="${ajax_url}?action=ar_frontend_download&filePath=${encodeURIComponent(item.relativePath)}">
                        ${downloadIconHtml}
                    </button>
                    <div id="tooltip-download-${item.relativePath.replace(/[^a-zA-Z0-9]/g, '-')}" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700">Scarica<div class="tooltip-arrow" data-popper-arrow></div></div>
                    ` : ''}
                </td>
            `;
            fileTableBody.appendChild(row);
        });
        initTooltips();
    };

    const initTooltips = () => { document.querySelectorAll('[data-tooltip-target]').forEach(el => { const targetId = el.getAttribute('data-tooltip-target'); const targetEl = document.getElementById(targetId); if (targetEl) { try { new Tooltip(targetEl, el, { triggerType: 'hover' }); } catch(e) { console.error("Errore init tooltip:", e); } } }); };

    const renderBreadcrumb = (path) => {
        if (!breadcrumbContainer) return;
        breadcrumbContainer.innerHTML = '';
        const rootLi = document.createElement('li'); rootLi.className = 'inline-flex items-center';
        const rootLink = document.createElement('a'); rootLink.href = '#'; rootLink.className = 'inline-flex items-center text-sm font-medium text-primary-dark dark:text-gray-400 hover:text-accent dark:hover:text-white'; rootLink.dataset.path = baseAccessPath; rootLink.title = currentFolderName;
        rootLink.innerHTML = `<i class="${getIconClass('home')} w-4 h-4 me-1.5"></i>`;
        rootLink.appendChild(document.createTextNode('Area Riservata')); rootLi.appendChild(rootLink); breadcrumbContainer.appendChild(rootLi);
        if (path && path !== baseAccessPath) {
            let relativeToBase = path.substring(baseAccessPath.length).replace(/^\//, ''); const parts = relativeToBase.split('/'); let currentCrumbPath = baseAccessPath;
            parts.forEach((part, index) => {
                if (!part) return; currentCrumbPath += (currentCrumbPath === '' ? '' : '/') + part;
                const li = document.createElement('li'); li.setAttribute('aria-current', index === parts.length - 1 ? 'page' : 'false');
                const div = document.createElement('div'); div.className = 'flex items-center';
                div.innerHTML = `<i class="${getIconClass('chevron-right')} w-3 h-3 text-gray-400 mx-1"></i>`;
                if (index === parts.length - 1) { const span = document.createElement('span'); span.className = 'ms-1 text-sm font-medium text-gray-500 md:ms-2 dark:text-gray-400'; span.textContent = part; div.appendChild(span); }
                else { const a = document.createElement('a'); a.href = '#'; a.className = 'ms-1 text-sm font-medium text-primary-dark dark:text-gray-400 hover:text-accent md:ms-2 dark:hover:text-white'; a.dataset.path = currentCrumbPath; a.textContent = part; div.appendChild(a); }
                li.appendChild(div); breadcrumbContainer.appendChild(li);
            });
        }
    };

    const loadFiles = async (path) => {
        if (!fileTableBody) return;
        fileTableBody.innerHTML = `<tr class="border-b dark:border-gray-700"><td colspan="4" class="px-4 py-6 text-center text-gray-500 dark:text-gray-400"><svg aria-hidden="true" class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg> ${text.loading}</td></tr>`;
        try {
            const data = await makeAjaxRequest('ar_frontend_list', { path: path });
            currentPath = data.currentPath;
            const displayPath = currentPath === baseAccessPath ? currentFolderName : currentPath.split('/').pop();
            if (folderTitle) folderTitle.textContent = displayPath;
            renderTable(data.items);
            renderBreadcrumb(data.currentPath);
            const newHash = currentPath === baseAccessPath ? '#' : `#${encodeURIComponent(currentPath)}`;
            if (window.location.hash !== newHash) {
               history.replaceState(null, null, newHash);
            }
        }
        catch (error) {
            // Non mostrare errore se è un errore di sessione (già gestito da makeAjaxRequest)
            if (error.message !== 'Session expired') {
                fileTableBody.innerHTML = `<tr class="border-b dark:border-gray-700"><td colspan="4" class="px-4 py-6 text-center text-red-500">${text.error_loading_folder}</td></tr>`;
            }
            // Resetta l'hash alla base path in caso di errore nel caricamento
            history.replaceState(null, null, baseAccessPath ? `#${encodeURIComponent(baseAccessPath)}` : '#');
        }
    };
    const loadFflate = () => { return new Promise((resolve, reject) => { if (fflate) { resolve(fflate); return; } const script = document.createElement('script'); script.src = fflate_cdn_url; script.onload = () => { fflate = window.fflate; if (fflate) { resolve(fflate); } else { reject(new Error('Errore zip.')); } }; script.onerror = (err) => { reject(new Error('Errore zip.')); }; document.body.appendChild(script); }); };
    const handleFileDownload = (downloadUrl) => {
        window.location.href = downloadUrl; // Semplice redirect per il download
    };

    // --- Gestione Eventi ---
    if (loginButton && passwordInput) {
        const handleLogin = async () => {
            const password = passwordInput.value.trim();
            if (!password) { showMessage(text.login_missing_password, 'warning'); return; }
            loginButton.disabled = true;
            loginButton.textContent = text.loading;
            try {
                const data = await makeAjaxRequest('ar_frontend_login', { password: password });
                baseAccessPath = data.folderPath;
                currentFolderName = (baseAccessPath === '') ? 'Area Riservata Base' : baseAccessPath.split('/').pop(); // Assumendo che folderName sia il nome base
                showView('manager');
                const initialPathFromHash = sanitizeHashPath(window.location.hash);
                loadFiles(initialPathFromHash || baseAccessPath); // Carica path dall'hash o base path
            } catch (error) {
                // L'errore viene già mostrato da makeAjaxRequest
                passwordInput.focus();
                passwordInput.select();
            } finally {
                loginButton.disabled = false;
                loginButton.textContent = 'Accedi';
            }
        };
        loginButton.addEventListener('click', handleLogin);
        passwordInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                handleLogin();
            }
        });
    }

    // *** CORREZIONE: Gestione click tabella FE ***
    if (appContainer) {
        appContainer.addEventListener('click', (e) => {
            const target = e.target;
            const tableRow = target.closest('#ar-file-table-body tr');
            const downloadButton = target.closest('.ar-download-btn');
            const breadcrumbLink = target.closest('#ar-breadcrumb a');

            if (downloadButton) { // Click sul pulsante download esplicito
                 e.preventDefault();
                 const downloadUrl = downloadButton.dataset.url; // Usa l'URL sicuro pre-costruito
                 if (downloadUrl) {
                    handleFileDownload(downloadUrl);
                 }
            } else if (tableRow && tableRow.dataset.relativePath) { // Click sulla riga
                 // Ignora se si clicca sul pulsante download interno alla riga
                 if (target.closest('.ar-download-btn')) {
                     return;
                 }

                const path = tableRow.dataset.relativePath;
                const isDir = tableRow.dataset.isDir === 'true';
                const name = tableRow.dataset.name;
                const directUrl = tableRow.dataset.url; // URL diretto per PDF/Immagini/Lightbox
                const fileType = getFileType(name);
                const downloadUrl = `${ajax_url}?action=ar_frontend_download&filePath=${encodeURIComponent(path)}`; // URL di download sicuro AJAX

                if (isDir) {
                    loadFiles(path); // Naviga nella cartella
                } else if (fileType === 'pdf') {
                     // Apri PDF in una nuova scheda (usa URL sicuro AJAX che imposta Content-Disposition: inline)
                     window.open(downloadUrl, '_blank');
                } else if (fileType === 'image') {
                     // Cerca il link nascosto (che usa l'URL diretto) e simula il click per la lightbox
                     const hiddenLink = tableRow.querySelector('a[data-lightbox-trigger]');
                     if (hiddenLink) {
                         hiddenLink.click();
                     } else {
                         // Fallback: Apri immagine in nuova scheda (URL diretto) se lightbox non trovato
                         if (directUrl) window.open(directUrl, '_blank');
                     }
                } else {
                    // *** MODIFICA: Usa testo generico per conferma download ***
                    if (window.confirm(text.confirm_download_text || `Non è possibile visualizzare un'anteprima per questo tipo di file. Vuoi scaricarlo?`)) {
                        handleFileDownload(downloadUrl); // Usa endpoint sicuro AJAX
                    }
                }
            } else if (breadcrumbLink && breadcrumbLink.dataset.path !== undefined) { // Click sul breadcrumb
                e.preventDefault();
                loadFiles(breadcrumbLink.dataset.path);
            }
        });
    }
    // *** FINE CORREZIONE: Gestione click tabella FE ***

    if (downloadZipButton && zipSpinner) {
        downloadZipButton.addEventListener('click', async () => {
            downloadZipButton.disabled = true;
            zipSpinner.hidden = false;
            showMessage(text.zipping_files, 'info');
            try {
                await loadFflate(); // Assicura che fflate sia caricato
                const data = await makeAjaxRequest('ar_frontend_get_zip_list', { path: currentPath });
                if (!data.files || data.files.length === 0) {
                    showMessage('Nessun file da zippare.', 'warning');
                    return;
                }
                const filesToZip = {};
                const fetchPromises = data.files.map(async (file) => {
                    try {
                        // Usa l'URL sicuro per scaricare il contenuto del file
                        const downloadUrl = `${ajax_url}?action=ar_frontend_download&filePath=${encodeURIComponent(file.path)}`; // Usa file.path
                        const response = await fetch(downloadUrl); // Usa l'URL sicuro
                        if (!response.ok) {
                            throw new Error(`Download fallito per ${file.name} (status: ${response.status})`);
                        }
                        const buffer = await response.arrayBuffer();
                        filesToZip[file.name] = new Uint8Array(buffer); // Usa il nome relativo allo zip
                    } catch (fetchError) {
                        console.error(`Errore recupero file per zip: ${file.name}`, fetchError);
                        showMessage(`Errore recupero: ${file.name}`, 'warning');
                    }
                });
                await Promise.all(fetchPromises);

                if (Object.keys(filesToZip).length === 0) {
                    showMessage('Nessun file recuperato per lo zip.', 'error');
                    return;
                }
                const zipData = fflate.zipSync(filesToZip);
                const blob = new Blob([zipData], { type: 'application/zip' });
                const zipFileName = `${currentPath.split('/').pop() || 'area-riservata'}.zip`;
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = zipFileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(link.href);
                showMessage('Archivio zip creato.', 'success');
            } catch (error) {
                console.error("Errore creazione ZIP:", error);
                showMessage(error.message || text.zip_error, 'error');
            } finally {
                downloadZipButton.disabled = false;
                zipSpinner.hidden = true;
            }
        });
    }

    if (logoutButton) {
        logoutButton.addEventListener('click', () => {
            clearAccessCookie();
            // Rimuovi l'hash dall'URL prima di ricaricare
            history.replaceState(null, null, window.location.pathname + window.location.search);
            window.location.reload();
        });
    }

    // --- Inizializzazione ---
    try {
        initFlowbite();
    } catch (e) {
        console.error("Errore init Flowbite:", e);
    }

    if (initial_state.is_logged_in) {
        baseAccessPath = initial_state.base_path;
        currentFolderName = initial_state.folder_name;
        showView('manager');
        const initialPathFromHash = sanitizeHashPath(window.location.hash);
        loadFiles(initialPathFromHash || baseAccessPath); // Carica path dall'hash o base path
    }
    else {
        showView('login');
         // Rimuovi l'hash se l'utente non è loggato
         if (window.location.hash) {
            history.replaceState(null, null, window.location.pathname + window.location.search);
         }
    }

}); // Fine DOMContentLoaded
